import styled from 'styled-components';

export const MobileAppForgotPasswordStyled = styled.div`
    display: flex;
    height: 100%;
    align-items: center;
    justify-content: center;
    padding: 16px;
    margin-bottom: 80px;
    text-align: center;

    .forgot-password-content__title,
    .forgot-password-content__check-email-title,
    .forgot-password-content__description {
        text-align: center;
        margin-bottom: 16px;
    }

    .forgot-password-content__description {
        font-size: 16px;
    }

    .forgot-password-content__email {
        margin-top: 24px;
        text-align: left;
    }

    .forgot-password-content__buttons-panel {
        margin-top: 24px;
    }
`;
